import React from 'react'

const PinkCheckIcon = (
  <path
    d="M3.75 20.5L20.4077 37.5625L53.723 3.4375"
    stroke="#FF5887"
    strokeWidth="6"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
  />
)

export default PinkCheckIcon
